import { client } from "../../shared/services/client";
import AllMortgageListModel from "../model/AllMortgageListModel";
import { AxiosResponse } from "axios";
import { MortageDetailsModel } from "../model/MortageDetailsModel";

const adminBaseKey = "admin";

class MortgageAPI {
    getAllMortgageCompanies = async (): Promise<AllMortgageListModel[]> => {
        client.setBaseURLForService(adminBaseKey);
        const res: AxiosResponse<AllMortgageListModel[]> = await client.get<AllMortgageListModel[]>("api/mortgage/GetAllMortgageCompanies");
        return res.data;
    }

    getAllMortgageCompaniesAsync = async (interestTypeId?: string): Promise<any[]> => {
        client.setBaseURLForService(adminBaseKey);
        const params = interestTypeId
            ? { interestTypeId }
            : undefined;

        const res: AxiosResponse<any[]> = await client.get<any[]>("api/mortgage/GetAllMortgageCompaniesAsync", { params });
        return res.data;
    }

    createMortgageCompany = async (mortgageCompany: MortageDetailsModel): Promise<string> => {
        client.setBaseURLForService(adminBaseKey);
        const res: AxiosResponse<string> = await client.post("api/mortgage/CreateMortgageCompany", mortgageCompany);
        return res.data;
    }

    updateMortgageCompany = async (mortgageCompany: MortageDetailsModel): Promise<string> => {
        client.setBaseURLForService(adminBaseKey);
        const res: AxiosResponse<string> = await client.post("api/mortgage/UpdateMortgageCompany", mortgageCompany);
        return res.data;
    }
}
export const mortgageAPI = new MortgageAPI();